import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { PlusCircle } from "lucide-react";

const UNITS = ["m²", "ml", "pz", "punto", "forfait", "h", "kg"];

// Riga del concorrente senza voce: la crea nelle Voci Backoffice e la abbina subito
export default function NuovaVoceDaRiga({ r, cats, onCreata }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(null);
  const apri = () => {
    const pu = Number(r.prezzo_unit) || 0;
    setF({ name: r.descrizione || "", category: cats.includes("EXTRA") ? "EXTRA" : cats[0] || "EXTRA", unit: UNITS.includes(r.unit) ? r.unit : "pz", prezzo_acquisto: Math.round((pu / 1.8) * 100) / 100, ricarico: 1.8 });
    setOpen(true);
  };
  const save = async () => {
    if (!f.name.trim()) return toast.error("Nome obbligatorio");
    try {
      const { data } = await api.post("/voci-backoffice", f);
      onCreata({ ...data, prezzo_rivendita: Math.round(data.prezzo_acquisto * data.ricarico * 100) / 100 });
      toast.success(`Voce "${data.name}" aggiunta alle voci back office`);
      setOpen(false);
    } catch (e) { toast.error(e.response?.data?.detail || "Creazione non riuscita: usa il prezzo manuale"); }
  };
  return (<>
    <button onClick={apri} className="text-[11px] text-emerald-700 underline inline-flex items-center gap-1" data-testid={`imp-nuova-voce-${r.idx}`}><PlusCircle className="h-3 w-3" />aggiungi alle voci back office</button>
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-md" data-testid="imp-nuova-voce-dialog">
        <DialogHeader><DialogTitle>Nuova voce back office</DialogTitle></DialogHeader>
        {f && <div className="space-y-3">
          <div><Label className="text-xs">Nome</Label><Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="imp-nv-nome" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label className="text-xs">Categoria</Label>
              <select value={f.category} onChange={(e) => setF({ ...f, category: e.target.value })} className="w-full h-9 border border-zinc-300 rounded px-1 text-sm" data-testid="imp-nv-cat">{cats.map((c) => <option key={c}>{c}</option>)}</select></div>
            <div><Label className="text-xs">Unità</Label>
              <select value={f.unit} onChange={(e) => setF({ ...f, unit: e.target.value })} className="w-full h-9 border border-zinc-300 rounded px-1 text-sm" data-testid="imp-nv-unit">{UNITS.map((u) => <option key={u}>{u}</option>)}</select></div>
            <div><Label className="text-xs">Prezzo acquisto €</Label><Input type="number" step="0.01" value={f.prezzo_acquisto} onChange={(e) => setF({ ...f, prezzo_acquisto: Number(e.target.value) })} data-testid="imp-nv-acq" /></div>
            <div><Label className="text-xs">Ricarico (x)</Label><Input type="number" step="0.1" value={f.ricarico} onChange={(e) => setF({ ...f, ricarico: Number(e.target.value) })} data-testid="imp-nv-ric" /></div>
          </div>
          <div className="text-xs text-zinc-500">Prezzo di vendita: € {(f.prezzo_acquisto * f.ricarico).toFixed(2)} / {f.unit} · concorrente: {r.prezzo_unit != null ? `€ ${Number(r.prezzo_unit).toFixed(2)}` : "—"}</div>
        </div>}
        <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Annulla</Button><Button onClick={save} style={{ background: "var(--brand)", color: "white" }} data-testid="imp-nv-salva">Crea e abbina</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  </>);
}
